import { useOutletContext } from "react-router-dom";
import { ContactDetails } from "@/features/person/components/ContactDetails";
import { Student } from "../../types";
import { CardSkeleton } from "@/components/Skeleton";
import EmptyState from "@/components/EmptyState";
import { usePersonContactDetailsQuery } from "@/pages/people/[pgaId]/person/_usePersonContactDetailsQuery";

export default function StudentContact() {
  const { student } = useOutletContext<{ student: Student }>();
  const { loaded, canViewPersonContact, person, error } = usePersonContactDetailsQuery(student.pgaId);

  if (!loaded || !canViewPersonContact) {
    return null;
  }

  if (error) {
    return <EmptyState title="Error" caption="An error occurred while loading contact information." iconName="error" />;
  }

  if (!person) {
    return (
      <div className="flex mt-12 gap-4">
        <CardSkeleton maxWidth={60} />
        <CardSkeleton maxWidth={60} />
      </div>
    );
  }

  return (
    <div>
      <ContactDetails person={person} />
    </div>
  );
}
